
export interface Drink {
  id: number;
  name: string;
  categoryId?: number;
  categoryName?: string;
  description?: string;
  price: number;
  stock: number;
  imageUrl?: string;
  lowStockThreshold?: number;
  barId?: string;
  overallRating?: number;
  serviceRating?: number;
  tasteRating?: number;
  isAvailable?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
